import { connect } from 'react-redux';

import CookiePolicyPlaceholder, {
  ICookiePolicyPlaceholderDispatchProps,
} from '../components/policies/cookiePolicy/CookiePolicyPlaceholder';

import { setCookiePolicyHtml } from '@store/actions';
import { CookiePolicyActionsType } from '@store/types';

const mapDispatchToProps = (
  dispatch: (action: CookiePolicyActionsType) => void
): ICookiePolicyPlaceholderDispatchProps => ({
  setPolicyHtml: (html: string) => dispatch(setCookiePolicyHtml(html)),
});

export default connect(null, mapDispatchToProps)(CookiePolicyPlaceholder);
